module.exports = __webpack_public_path__ + "static/media/final-temp-icon.e6d849ca.svg";